import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showFailToast, showSuccessToast} from "vant";


const apiBaseUrl = `${process.env.VUE_APP_API_URL}`;
const baseUrl = apiBaseUrl + '/ecommerce/orders';

export const useOrdersStore = defineStore({
  id: 'orders',
  state: () => ({
    orders: [],
    order: {},
    payment: {
      user_payment_json: {
        credit_card_name: '',
        credit_card_number: '',
        credit_card_cvv: '',
        expiry_month: '',
        expiry_year: '',
      },
      user_billing_json: {
        first_name: '',
        last_name: '',
        address1: '',
        city: '',
        state: '',
        zip: ''
      },
    },
  }),

  actions: {
    async fetchAll(status) {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      let url = `${baseUrl}` + '?account_id=' + accountId;
      if (status !== 'all') {
        url += '&status=' + status;
      }

      await fetchWrapper.get(url, null).then(response => {
        this.orders = response.data;
      })
    },

    async fetchOne(orderId) {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      await fetchWrapper.get(`${baseUrl}/` + orderId + '?account_id=' + accountId, null).then(response => {
        this.order = response.data;
        if (this.order.payment) {
          this.payment = this.order.payment;
        }
      })
    },

    async create(productId) {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      await fetchWrapper.post(`${baseUrl}` + '?account_id=' + accountId, {
        ecommerce_product_ids: [productId]
      }).then(response => {
        this.order = response.data;
        this.$router.push('/order/' + this.order.id);
      }).catch(error => {
          console.log(error);
          showFailToast({
            message: 'Order creation failed',
            wordBreak: 'break-word',
          });
      });
    },

    async pay() {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      const paymentRequest = {
        account_id: accountId,
        order_id: this.order.id,
        first_name: this.payment.user_billing_json.first_name,
        last_name: this.payment.user_billing_json.last_name,
        address1: this.payment.user_billing_json.address1,
        city: this.payment.user_billing_json.city,
        state: this.payment.user_billing_json.state,
        zip: this.payment.user_billing_json.zip,
        credit_card_name: this.payment.user_payment_json.credit_card_name,
        credit_card_number: this.payment.user_payment_json.credit_card_number,
        credit_card_cvv: this.payment.user_payment_json.credit_card_cvv,
        expiry_year: this.payment.user_payment_json.expiry_year,
        expiry_month: parseInt(this.payment.user_payment_json.expiry_month),
      };

      await fetchWrapper.post(`${baseUrl}/` + this.order.id + '/pay', paymentRequest)
        .then(response => {
          const payment = response.data;
          if (payment.status === 'failed') {
            showFailToast({
              message: 'Payment failed',
              wordBreak: 'break-word',
            });
          } else {
            showSuccessToast('Payment Successful');
            this.$router.push(`/session/list`);
          }
        }).catch(error => {
            console.log(error);
            showFailToast({
              message: 'Payment interrupted, please try again later',
              wordBreak: 'break-word',
            });
        });
    }
  }
});
